// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"NotAccessibleErrors_textWrapper__BrDrW","link":"NotAccessibleErrors_link__sY4oC"};